<template>
  <div>
    <a-card style="border: none; border-radius: 12px; margin-bottom: 20px">
      <a-form layout="inline">
        <a-form-item>
          <a-input v-model="dataForm.name" placeholder="姓名"> </a-input>
        </a-form-item>
        <a-form-item>
          <a-button @click="getDataList" type="primary"> 搜索 </a-button>
        </a-form-item>
        <a-form-item>
          <a-button @click="addpromptdia" v-permission="['health:exam:add']">
            新增
          </a-button>
        </a-form-item>
      </a-form>
    </a-card>
    <a-card style="border: none; border-radius: 12px">
      <a-table
        :columns="columns"
        :data-source="dataList"
        :pagination="false"
        :loading="dataListLoading"
        :scroll="{ x: 1500 }"
      >
        <span slot="action" slot-scope="text, record">
          <a-space>
            <a-button
              size="small"
              type="link"
              @click="addOrUpdateHandle(record.id)"
              v-permission="['health:exam:edit']"
              >编辑
            </a-button>
            <a-button
              size="small"
              type="link"
              @click="deleteHandle(record.id)"
              v-permission="['health:exam:delete']"
              >删除</a-button
            >
          </a-space>
        </span>
        <!-- <span slot="project_name" slot-scope="text">
          <a-tag color="green">
            {{ text }}
          </a-tag>
        </span> -->
      </a-table>
      <a-pagination
        style="margin-top: 20px; float: right"
        show-size-changer
        :current="page"
        show-quick-jumper
        :total="total"
        @showSizeChange="showSizeChange"
        @change="pageCurrentChangeHandle"
        :show-total="(total) => `共 ${total} 条`"
      />
    </a-card>
    <addOrUpdate ref="addOrUpdate" @ok="getDataList"></addOrUpdate>
    <addprompt
      ref="addprompt"
      @addOrUpdateHandle="addOrUpdateHandle"
    ></addprompt>
  </div>
</template>

<script>
import addOrUpdate from "./components/addexamaddorupdate.vue";
import viewModule from "@/mixins/view-module";
import addprompt from "./components/addprompt.vue";
export default {
  components: { addOrUpdate, addprompt },
  mixins: [viewModule],
  data() {
    return {
      columns: [
        {
          title: "序号",
          dataIndex: "key",
          key: "key",
          width: 60,
          align: "center",
          customRender: (text, record, index) => {
            return (this.page - 1) * this.limit + index + 1;
          },
        },
        {
          title: "姓名",
          align: "center",
          dataIndex: "name",
          key: "name",
          width: 120,
        },
        {
          title: "所属分包单位",
          align: "center",
          dataIndex: "company_name",
          key: "company_name",
          width: 250,
        },
        {
          title: "身高/cm",
          align: "center",
          dataIndex: "height",
          key: "height",
          width: 200,
        },
        {
          title: "体重/kg",
          align: "center",
          dataIndex: "weight",
          key: "weight",
          width: 200,
        },
        {
          title: "血压",
          align: "center",
          dataIndex: "sbp",
          key: "sbp",
          customRender: (text, record, index) =>
            `${record.sbp && record.dbp ? record.sbp + "/" + record.dbp : ""}`,
          width: 200,
        },
        {
          title: "心率/次",
          align: "center",
          dataIndex: "hr",
          key: "hr",
          width: 200,
        },
        {
          title: "年龄/周岁",
          align: "center",
          dataIndex: "age",
          key: "age",
          width: 100,
        },
        {
          title: "操作",
          key: "action",
          align: "center",
          scopedSlots: { customRender: "action" },
          fixed: "right",
        },
      ],
      mixinViewModuleOptions: {
        getDataListURL: "/health/page",
        deleteURL: "/health/delete",
        activatedIsNeed: true
      },
      dataForm: { name: "" },
    };
  },
  methods: {
    addpromptdia() {
      this.$refs.addprompt.showModal();
    },
  },
};
</script>

<style></style>